import React from "react"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { queries } from  "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel
} from "react-accessible-accordion"

const FaqFullWrap = styled.div`
  border-top: 1px solid ${theme.wild.color.master.base.alt.secondary};
`

const StyledAccordionItem = styled(AccordionItem)`
  border-bottom: 1px solid ${theme.wild.color.master.base.alt.secondary};
  > button {
    width: 100%;
  }

  > button:hover {
    background: ${theme.wild.color.master.secondary.alt};
  }

  span.toggle-icon:before {
    content: "+";
  }

  div[aria-expanded="true"] span.toggle-icon:before {
    content: "-";
  }

  .text p {
    margin-bottom: 16px;
    &:last-of-type {
      margin: 0;
    }
  }
`

const StyledAccordionItemButton = styled(AccordionItemButton)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  outline: none !important;
  padding: 24px 0;

  ${queries.medium`
    padding: 16px;
  `}

  ${queries.large`
    padding: 24px 40px;
  `}

  ${queries.large`
    h4 {
      font-size: 18px !important;
    }
  `}
`

const StyledAccordionItemPanel = styled(AccordionItemPanel)`
  padding: 24px 0;  
  a {
    text-decoration: underline;
  }
  ${queries.medium`
    padding: 24px 32px;
  `}

  ${queries.large`
    padding: 24px 64px;
  `}

  h5 {
    padding: 0 16px 24px 0;
  } 
`

const FaqItem = ({ questions}) => {
  const clickHandler = (e, section) => {
    try {
      if (e.target.closest("div[aria-expanded]").getAttribute('aria-expanded') === 'false') {
        segmentEvent('Section Expanded', { section })
      } else {
        segmentEvent('Section Collapsed', { section })
      }
    } catch (e) {
      //error
    }
  }

  return (
    <FaqFullWrap>
      <Accordion allowZeroExpanded={true}>
        {questions.map((question, idx) => (
          <StyledAccordionItem key={idx}>
            <button onClick={(e)=> clickHandler(e, question.title)}>
              <StyledAccordionItemButton>
                <TextElementMen text={question.title} element={`h3`} className="mono--small uppercase text-men-secondary-secondary text-left" />
                <span className="toggle-icon"></span>
              </StyledAccordionItemButton>
            </button>
            <StyledAccordionItemPanel>
              <TextElementMen element="h5" text={question.answer} className="text body--regular text-men-secondary-secondary"/>
            </StyledAccordionItemPanel>
          </StyledAccordionItem>
        ))}
      </Accordion>
    </FaqFullWrap>
  )

}

export default FaqItem
